"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreStep = void 0;
const React = __importStar(require("react"));
const _1 = require(".");
const type_1 = require("../../../type");
const Field_InitialReferenceStep_1 = require("../utils/Field.InitialReferenceStep");
const CoreSelfStep_1 = require("./CoreSelfStep");
const CoreStep = (props) => {
    (0, Field_InitialReferenceStep_1.FieldInitialReferenceStep)(props);
    if ((props === null || props === void 0 ? void 0 : props.childType) === type_1.TYPE_OBJECT) {
        return (React.createElement(_1.FunctionCore, { showSymbol: props.showSymbol, initalValue: props === null || props === void 0 ? void 0 : props.initalValue, language: props.language, mode: props.mode, fields: props === null || props === void 0 ? void 0 : props.fields, parentKey: props.parentKey, FieldReference: props.FieldReference, parentIndex: props.parentIndex, grandParentKey: props.grandParentKey, grandParentIndex: props.grandParentIndex, showError: props.showError, childType: props.childType, loadData: props.loadData, validateDataNoChange: props === null || props === void 0 ? void 0 : props.validateDataNoChange }));
    }
    else {
        return React.createElement(CoreSelfStep_1.CoreSelfStep, { props: props });
    }
};
exports.CoreStep = CoreStep;
